import React from 'react'

const Heading = (props)=>{
    return <h3 className="production-name">{props.name}</h3>
}

export default Heading;